var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayMessage)?_c('error-component',{attrs:{"message":_vm.displayMessage,"has-error":_vm.hasError}},[_c('p',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }